import Footer from './Footer/Footer';
import FooterBigIcons from './Footer/FooterBigIcons/FooterBigIcons';
import NewsletterForm from './Footer/NewsletterForm/NewsletterForm';
import { AccessibilityNavigation } from './Header/AccessibilityNavigation/AccessibilityNavigation';
import { Header } from './Header/Header';
import NotificationBars from './NotificationBars/NotificationBars';
import Webline from './Webline/Webline';
import SeoMeta from 'components/Basic/Head/SeoMeta';
import Adverts from 'components/Blocks/Adverts/Adverts';
import LastVisitedProducts from 'components/Blocks/Product/LastVisitedProducts/LastVisitedProducts';
import { SkeletonManager } from 'components/Blocks/SkeletonManager/SkeletonManager';
import { useMediaMin } from 'hooks/ui/useMediaMin';
import useTranslation from 'next-translate/useTranslation';
import { useSessionStore } from 'store/useSessionStore';
import { OgTypeEnum } from 'types/seo';

type LayoutProps = {
    title?: string | null;
    description?: string | null;
    showLastVisitedProducts?: boolean;
    isFetchingData?: boolean;
    withoutMoveUpActionButton?: boolean;
    ogType?: OgTypeEnum | undefined;
    ogImageUrlDefault?: string | null | undefined;
};

/**
 * Basic page layout for common pages
 */
const CommonLayout: FC<LayoutProps> = ({
    children,
    title,
    description,
    showLastVisitedProducts,
    isFetchingData,
    withoutMoveUpActionButton,
    ogType,
    ogImageUrlDefault,
}) => {
    const isDesktop = useMediaMin('vl');
    const { isPageLoading, destinationOfRedirect } = useSessionStore((s) => s);
    const { t } = useTranslation();

    return (
        <>
            <SeoMeta title={title} description={description} ogType={ogType} ogImageUrlDefault={ogImageUrlDefault} />
            <AccessibilityNavigation />
            <NotificationBars />
            <Header simple={destinationOfRedirect === 'transport-and-payment'} />
            <main
                aria-label={title ? t('Main content: {{pageTitle}}', { pageTitle: title }) : t('Main content')}
                id="main-content"
            >
                <Adverts positionName="header" withGapBottom withWebline />
                <SkeletonManager isFetchingData={isFetchingData}>{children}</SkeletonManager>
                {showLastVisitedProducts && !isPageLoading && !isFetchingData && <LastVisitedProducts />}
            </main>
            <Webline>
                <FooterBigIcons />
            </Webline>
            {(isDesktop || isDesktop === undefined) && (
                <Webline type="light" className="hidden vl:block">
                    <NewsletterForm />
                </Webline>
            )}
            <Webline type="light">
                <Footer withoutMoveUpActionButton={withoutMoveUpActionButton} />
            </Webline>
        </>
    );
};

/* @component */
export default CommonLayout;
